<template>
  <div class="background-setting" :style="{left: active ? 0 : '-100%'}">
    <div class="basic-setting">
      <div class="basic-title">背景设置</div>
      <div class="basic-show" :style="{background: bgCss}"></div>
      <div class="basic-button">
        <div :class="{'disable': !clip, 'basic-cut': true}" @click="clipClick($event)">剪辑时长</div>
        <div class="basic-delete" @click="setColor('#FFFFFF')">删除背景</div>
        <label for="videoAndImage">
          <div class="basic-upload">上传背景</div>
        </label>
      </div>
      <div class="basic-swap" @click="swapBg">
        <i class="icon-set-swap"></i>
        <span>替换背景</span>
      </div>
      <div class="basic-color">
        <span>纯色</span>
        <div class="color-list">
          <div class="color-open" @click="openBgColor"></div>
          <div v-for="v in colorList" :style="{'backgroundColor': v}" @click="setColor(v)"></div>
        </div>
      </div>
      <div class="basic-opacity">
        <SliderSetting :list="opacity" @changeData="opacityChange" />
      </div>
      <div class="basic-zoom" v-if="type !== 'Color'">
        <span>变焦</span>
        <el-popover
          v-model="isShowZoomList"
          class="el-dropdown"
          popper-class="stroke-width-dropdown"
          placement="bottom"
          width="180"
          trigger="click"
        >
          <div class="el-dropdown-link" slot="reference">
            <span>{{zoomScales[zoomIndex].name}}</span>
            <i
              class="icon-dropdown-arrow"
              :style="{transform: isShowZoomList ? `rotate(180deg)` : ''}"
            ></i>
          </div>
          <div class="dropdown__options">
            <div
              class="dropdown__item"
              v-for="item, i in zoomScales"
              :key="i"
              :class="{active: item.active}"
              @click="setZoomScale(item, i)"
            >
              <span>{{item.name}}</span>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="basic-laying" v-if="type === 'Image'">
        <span>铺设</span>
        <div>
          <el-tooltip
            effect="dark"
            placement="bottom"
            v-for="v, i in layingList"
            :key="i"
            :content="v.text"
          >
            <div :class="{active: v.active}" @click="changeLaying(v, i)">
              <i :class="{[`icon-laying-${v.type}`]: true}"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="filter-setting-content" v-if="type !== 'Color'">
      <FilterSetting :filters="filters" @changeData="filterChange" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations} from "vuex";
import SliderSetting from "./sliderSetting.vue";
import FilterSetting from "./filterSetting.vue";

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      type: "Color",
      bgCss: "#ffffff",
      colorList: ["#ffea01", "#5778fb", "#ff1844", "#ff6a0e"],
      layingList: [
        { type: "fit", text: "适应", active: false },
        { type: "fill", text: "填充", active: false },
        { type: "stretch", text: "拉伸", active: false },
        { type: "tile", text: "平铺", active: false }
      ],
      layingIndex: 0,
      clip: false,
      isShowZoomList: false,
      zoomScales: [
        {
          num: 1.25,
          type: "zoomIn",
          name: "拉近1.25倍",
          start: 1,
          end: 1.25,
          active: false
        },
        {
          num: 1.5,
          type: "zoomIn",
          name: "拉近1.5倍",
          start: 1,
          end: 1.5,
          active: false
        },
        {
          num: 1.75,
          type: "zoomIn",
          name: "拉近1.75倍",
          start: 1,
          end: 1.75,
          active: false
        },
        {
          num: 2,
          type: "zoomIn",
          name: "拉近2倍",
          start: 1,
          end: 2,
          active: false
        },
        {
          num: 1,
          type: "none",
          name: "焦距不变",
          start: 1,
          end: 1,
          active: false
        },
        {
          num: 1.25,
          type: "zoomOut",
          name: "拉远1.25倍",
          start: 1.25,
          end: 1,
          active: false
        },
        {
          num: 1.5,
          type: "zoomOut",
          name: "拉远1.5倍",
          start: 1.5,
          end: 1,
          active: false
        },
        {
          num: 1.75,
          type: "zoomOut",
          name: "拉远1.75倍",
          start: 1.75,
          end: 1,
          active: false
        },
        {
          num: 2,
          type: "zoomOut",
          name: "拉远2倍",
          start: 2,
          end: 1,
          active: false
        }
      ],
      zoomIndex: 4,
      opacity: [
        {
          name: "透明度",
          type: "opacity",
          step: 1,
          min: 0,
          max: 100,
          len: 100,
          val: 0,
          unit: "%"
        }
      ],
      filters: {}
    };
  },
  computed: {
    ...mapGetters(["TOOL", "SelectScenes_Msg"])
  },
  watch: {
    active: function() {
      this.initData();
    },
    "SelectScenes_Msg.id": function() {
      if (this.SelectScenes_Msg) {
        this.initData();
      }
    }
  },
  mounted() {
    eve.on("sceneBgAdded", () => {
      // 这里的逻辑有点问题，但是不会同时在加载的时候同时切换场景页，应该没有问题
      this.initData();
    });
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
    this.initData();
  },
  methods: {
    ...mapMutations({
      setChoosedResourceType: 'materialArea/setChoosedResourceType',
      setShelters: 'materialArea/setShelters'
    }),
    initData() {
      if (!this.active) return;
      let bg = this.SelectScenes_Msg.background;
      if (!bg) return;
      let bgData = bg.data;
      this.type = bgData.type;
      this.opacity[0].val = this.opacityT(bgData.data.opacity, true);
      if (bg.zoomActive) {
        let zoom = bg.zoomOptions;
        for (let i = 0; i < this.zoomScales.length; i++) {
          if (
            this.zoomScales[i].start === zoom.startScale &&
            this.zoomScales[i].end === zoom.endScale
          ) {
            this.zoomScales[this.zoomIndex].active = false;
            this.zoomScales[i].active = true;
            this.zoomIndex = i;
            break;
          }
        }
      } else {
        this.zoomScales[this.zoomIndex].active = false;
        this.zoomIndex = 4;
        this.zoomScales[4].active = true;
      }
      this.filters = Object.assign({}, bg.filter);
      if (this.type === "Color") {
        this.bgCss = bgData.data.color;
        this.clip = false;
      } else if (this.type === "Image") {
        this.bgCss = `url("${this.$handleAssetsUrl(
          bgData.data.url
        )}") center/contain no-repeat`;
        this.layingList[this.layingIndex].active = false;
        for (let j in this.layingList) {
          if (this.layingList[j].type === bgData.laying) {
            this.layingIndex = +j;
            this.layingList[j].active = true;
            break;
          }
        }
        this.clip = false;
      } else if (this.type === "Video") {
        this.bgCss = `url("${this.$handleAssetsUrl(
          bgData.data.poster
        )}") center/contain no-repeat`;
        this.clip = true;
      }
    },
    opacityT(val, bol) {
      if (bol) {
        return Math.round((1 - val) * 100);
      } else {
        return +(1 - val / 100).toFixed(2);
      }
    },
    setColor(hex) {
      let bgOpts = {
        resourceId: null,
        fileType: null,
        type: "Color",
        data: {
          color: hex,
          blur: 0,
          opacity: 1
        },
        zoomActive: false
      };
      this.SelectScenes_Msg.setBackground(bgOpts, null, true);
    },
    opacityChange(val, status) {
      let bol = false;
      if (status === "end") bol = true;
      this.SelectScenes_Msg.setBackgroundOpacity(this.opacityT(val), bol, bol);
    },
    setZoomScale(item, i) {
      if (item.active) return;
      this.zoomScales[this.zoomIndex].active = false;
      item.active = true;
      this.zoomIndex = i;
      this.SelectScenes_Msg.setBgZoom(
        true,
        {
          startScale: item.start,
          endScale: item.end,
          endTime:
            this.SelectScenes_Msg.background.zoomOptions.endTime ||
            this.SelectScenes_Msg.duration / 1000
        },
        true
      );
      this.isShowZoomList = false;
      this.$bus.emit("bgZoom.playScene");
    },
    changeLaying(v, i) {
      if (v.active) return;
      v.active = true;
      this.layingList[this.layingIndex].active = false;
      this.layingIndex = i;
      this.SelectScenes_Msg.setBgLaying(v.type, true);
    },
    filterChange(val, status, type) {
      let bol = false,
        data = {};
      data[type] = val;
      if (status === "end") bol = true;
      this.SelectScenes_Msg.setBackgroundFilter(data, bol, bol);
    },
    clipClick(el) {
      let rect = el.target.getBoundingClientRect();
      this.$bus.emit("FeaturesPop_vue", {
        name: "clipSetting.bg",
        type: 1,
        initialX: rect.left - 260,
        initialY: rect.top + 30
      });
    },
    _undoRedoHandle({ type, mod } = {}) {
      if (type === "setBackgroundOpacity") {
        this.opacity[0].val = this.opacityT(
          this.SelectScenes_Msg.background.data.data.opacity,
          true
        );
      } else if (type === "setBackgroundFilter") {
        this.filters = Object.assign(
          {},
          this.SelectScenes_Msg.background.filter
        );
      }
    },
    swapBg() {
      this.$store.commit("save_BgOperation", "swap");
      this.$bus.emit('open-resource-area', {
        index: 2,
        callbackFunc: 'changeBgType',
        props: {
          name: '静态背景',
          type: 'static'
        }
      })
      this.setShelters([2,7]);
    },
    openBgColor() {
      this.$bus.emit('open-resource-area', {
        index: 2,
        callbackFunc: 'changeBgType',
        props: {
          name: '纯色/渐变',
          type: 'pure'
        }
      });
    }
  },
  components: {
    SliderSetting,
    FilterSetting
  },
  beforeDestroy() {
    eve.off("sceneBgAdded");
    this.$bus.off("undoRedoHandle", this._undoRedoHandle);
  }
};
</script>
<style lang="scss" scoped>
.background-setting {
  position: absolute;
  top: 0;
  left: 0;
  width: 226px;
  color: #737596;
  transition: all 0.3s;
}
.basic-setting {
  border-bottom: 1px solid #d4d4e7;
}
.basic-title {
  text-align: left;
  padding: 10px 0 9px;
  color: #474261;
  font-weight: bold;
}
.basic-show {
  width: 226px;
  height: 127px;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  margin: 0 auto;
}
.basic-button,
.basic-color,
.basic-zoom,
.basic-laying,
.basic-opacity {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
}
.basic-button {
  margin: 8px 0 16px;
  div {
    width: 70px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #d9ddea;
    border-radius: 4px;
    cursor: pointer;

    &:hover:not(.disable) {
      background-color: #5778fb;
      border-color: #5778fb;
      color: #fff;
    }
  }

  .disable {
    color: #dddddd;
    cursor: not-allowed;
  }
}
.basic-swap {
  margin: 15px 0;
  display: flex;
  height: 30px;
  justify-content: center;
  align-items: center;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  cursor: pointer;

  i {
    width: 14px;
    height: 14px;
    margin-right: 8px;
  }

  &:hover {
    border-color: #5778fb;
  }
}
.basic-color {
  .color-open {
    background: conic-gradient(
      #ff7e00 0,
      #ff4040 16%,
      #ff3feb 32%,
      #2d46ff 48%,
      #2dfcff 64%,
      #00ff12 81%,
      #80fe09 84%,
      #fffc00 100%
    );
  }

  .color-list {
    width: 175px;
    display: flex;
    justify-content: space-between;

    div {
      width: 30px;
      height: 25px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 180px;
    height: 30px;
    line-height: 30px;
    border: solid 1px #d9dde9;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 180px;
    border: solid 1px #d9dde9;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;

    & > span:nth-child(1) {
      width: 100%;
      text-align: center;
      color: #9692a9;
    }
    &:hover,
    &.active {
      background-color: #d9dde9;
    }
  }
}
.el-dropdown {
  width: 175px;
  height: 30px;
  line-height: 30px;
  border: solid 1px #d9dde9;
  margin-left: 15px;
  cursor: pointer;
  text-align: left;
  padding-left: 12px;
  padding-right: 12px;
}
.el-dropdown-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
}
.icon-dropdown-arrow {
  transition-duration: 0.2s;
}
.basic-laying {
  > div {
    width: 175px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border: 1px solid #f0f0f8;
      border-radius: 4px;
      background-color: #f0f0f8;
      cursor: pointer;

      &:hover {
        background-color: #d8d8e9;
        border-color: #d8d8e9;
      }

      &.active {
        border-color: #5778fb;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/bgSetting.vue